<template>
  <v-app id="inspire" app dark :style="{ background: $vuetify.theme.themes[theme].background }">
    <SplashScreen :visible="showSplashScreen" />
    <!-- <v-system-bar ></v-system-bar> -->
    <NavigationDrawer :drawer="drawer" @toggle-help-dialog="toggleHelpDialog"  class="d-none d-md-flex" />
    <HelpDialog :showHelpDialog="showHelpSupportDialog" @closeHelpDialog="showHelpSupportDialog = false" />

    <app-bar  @toggle-drawer="onToggleDrawer" />

    <v-main class="pb-0">
      <SessionExpiredBanner :showBanner="showSessionExpiredBanner" :imageUrl="imageUrl" />
      <!-- <SessionWarningBanner :showBanner="showSessionWarningBanner" /> -->

      <v-container fluid class="pa-0 px-2 app-container">
        <v-row>
          <v-col cols="12" sm="12" md="12" >
            <!-- <v-hover v-slot="{ hover }">
              <v-fab-transition>
                <v-btn rounded small :filled="hover" @click="showHelpSupportDialog = true" fixed bottom right
                  class="z-10 need-help-btn">
                  <v-icon class="mr-1">
                    mdi-face-agent
                  </v-icon>
                  <span>
                    Need help?
                  </span>

                </v-btn>
              </v-fab-transition>
            </v-hover>
            <HelpDialog :showHelpDialog="showHelpSupportDialog" @closeHelpDialog="showHelpSupportDialog = false" /> -->

            <router-view :key="$route.fullPath" />
          </v-col>
        </v-row>
        <BottomNavigation @toggle-help-dialog="toggleHelpDialog" v-show="$vuetify.breakpoint.smAndDown"/>

      </v-container>
      <div >

      </div>
      <app-footer  />

    </v-main>
    <!-- short text need more duplicates -->

    <!-- <v-snackbar v-model="showSnackbar" :timeout="snackbarTimeout" top right  app>
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="refreshPage">
          Refresh
        </v-btn>
      </template>
</v-snackbar> -->
  </v-app>
</template>

<!-- import style.css here -->
<style>
@import '@/assets/styles/style.css';

/* .pad-main-row {
  padding-left: 10rem;
  padding-right: 10rem;
} */
.need-help-btn {
  margin-right: 15px;
  margin-bottom: 15px;
}
</style>

<script>
import Cookies from 'js-cookie'
import { EventBus } from './helpers/eventBus'
import AppBar from './components/AppBar.vue'
import BottomNavigation from './components/BottomSheet.vue'
import AppFooter from './components/AppFooter.vue'
import NavigationDrawer from './components/NavigationDrawer.vue'
import HelpDialog from './components/HelpDialog.vue'
import SplashScreen from './components/SplashScreen.vue'
import SessionExpiredBanner from './components/SessionExpiredBanner.vue'
import sessionExpiredImage from './assets/session-expired.svg'

// import SessionWarningBanner from './components/SessionWarningBanner.vue'
export default {
  name: 'App',
  components: {

    AppBar,
    BottomNavigation,
    AppFooter,
    NavigationDrawer,
    HelpDialog,
    SplashScreen,
    SessionExpiredBanner
    // SessionWarningBanner
  },
  data: () => ({

    duration: 10,
    logoUrl: '../assets/lilly_logo_55.png',
    drawer: false,
    navigations: [
      { name: 'Home', link: '/' }
    ],
    showSplashScreen: true,
    showHelpSupportDialog: false,
    showSessionExpiredBanner: false,
    showSessionWarningBanner: false,
    bannerMessage: 'Oops! Your session has expired. Please refresh the page.',
    checkInterval: null,
    reminderTimeout: null,
    imageUrl: sessionExpiredImage

  }),
  methods: {
    toggleHelpDialog () {
      this.showHelpSupportDialog = !this.showHelpSupportDialog
    },
    onToggleDrawer () {
      this.drawer = !this.drawer
    },

    animateSplashScreen () {
      const delay = ms => new Promise(resolve => setTimeout(resolve, ms))
      const hideSplashScreen = async () => {
        await delay(2 * 1000)
        this.showSplashScreen = false
      }
      hideSplashScreen()
    },
    checkAccessToken () {
      console.log('Checking access token... in App.vue')
      const accessToken = this.$userInfo.profile.accessToken
      if (!accessToken) {
        console.log('Access token not found. Showing session expired banner.')
        // this.$router.push('/')
        this.showSessionExpiredBanner = true

        if (this.checkInterval) {
          clearInterval(this.checkInterval)
        }
      } else {
        console.log('Access token found, not showing session expired banner.')
      }
    },
    refreshPage () {
      window.location.href = '/' + '?cache_bust=' + new Date().getTime()
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
      this.bannerMessage = 'You are offline. Please check your internet connection.'
      this.showSessionExpiredBanner = true
      if (navigator.serviceWorker.controller) {
        console.log('Sending OFFLINE message to service worker')
        navigator.serviceWorker.controller.postMessage({ type: 'OFFLINE' })
      } else {
        console.log('No service worker controller found')
      }
    },
    online () {
      console.log('The app is online.')
    },
    setReminderForTokenExpiry () {
      const accessToken = Cookies.get('accessToken')
      if (accessToken) {
        const cookieString = document.cookie.split('; ').find(row => row.startsWith('accessToken='))
        if (cookieString) {
          const cookieParts = cookieString.split(';')
          const expiresPart = cookieParts.find(part => part.startsWith('expires='))
          if (expiresPart) {
            const expiresDate = new Date(expiresPart.split('=')[1])
            const currentTime = new Date()
            const timeToExpiry = expiresDate - currentTime
            const timeToReminder = timeToExpiry - (5 * 60 * 1000) // 5 minutes before expiry

            if (timeToReminder > 0) {
              this.reminderTimeout = setTimeout(() => {
                this.bannerMessage = 'Your session will expire in 5 minutes.'
                this.showSessionWarningBanner = true
              }, timeToReminder)
            }
          }
        }
      }
    }

  },
  mounted () {
    // Simulate a delay to hide the splash screen
    this.animateSplashScreen()

    // Check the access token every minute
    if (process.env.VUE_APP_DEPLOYMENT_ENV === 'local') {
      console.log('Running in local environment. Skipping access token check.')
    } else {
      this.checkInterval = setInterval(() => {
        this.checkAccessToken()
      }, 60000) // Check the access token every minute
    }

    // Add an event listener for messages from the service worker
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', event => {
        console.log('New event from serviceWorker:', event.data)
        if (event.data) {
          switch (event.data.type) {
            case 'UPDATE_FOUND':
              console.log('Update found. New content is downloading.')
              break
            case 'UPDATE_COMPLETED':
              console.log('New content is available; please refresh.')
              break
            case 'OFFLINE':
              console.log('The app is offline.')
              break
            case 'ONLINE':
              console.log('The app is online.')
              break
            default:
              break
          }
        }
      })
    }

    window.addEventListener('offline', this.offline)
    window.addEventListener('online', this.online)

    EventBus.$on('session-expired', () => {
      console.log('Session expired captured')
      this.showSessionExpiredBanner = true
    })
    this.setReminderForTokenExpiry()
  },
  beforeDestroy () {
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
    }
    if (this.reminderTimeout) {
      clearTimeout(this.reminderTimeout)
    }
  },
  created () {
    // get the user's choice of terms and conditions from the local storage and show the terms and conditions dialog if not stored or false
    // console.log('darkMode', localStorage.getItem('darkMode') === 'true')

    // listen for service worker messages
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', event => {
        console.log('New event from serviceWorker:', event.data)
        if (event.data) {
          switch (event.data.type) {
            case 'UPDATE_FOUND':
              console.log('Update found. New content is downloading.')
              break
            case 'UPDATE_COMPLETED':
              console.log('New content is available; please refresh.')
              break
            case 'OFFLINE':
              console.log('The app is offline.')
              break
            case 'ONLINE':
              console.log('The app is online.')
              break
            default:
              break
          }
        }
      })
    }

    // Prefetch the image
    const img = new Image()
    img.src = this.imageUrl
  },
  computed: {
    theme () {
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  }

}

</script>
